import { Container, Typography, Box } from '@mui/material';
import React from 'react';
import PaypalIcon from '../../assets/images/paypalImage.png';

const SecurePayment = () => (
  <Container
    disableGutters
    maxWidth={false}
    sx={{
      background: '#FF6B0033',
      textAlign: 'center',
      my: 6,
      py: 2,
      px: { xs: 2, md: 4 },
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Typography
      color="#023C67"
      sx={{
        fontFamily: 'Lato',
        letterSpacing: '0%',
        textTransform: 'uppercase',
        fontWeight: '700',
        fontSize: { xs: '0.9rem', sm: '1rem' },
        textAlign: { xs: 'center', sm: 'left' },
      }}
    >
      Secure Payment Processing with
    </Typography>

    <Box pt={{ xs: 1, sm: 0 }} pl={{ xs: 0, sm: 2 }}>
      <img
        src={PaypalIcon}
        alt="paypal-icon"
        style={{
          width: 'auto',
          height: '32px',
          maxWidth: '120px',
        }}
      />
    </Box>
  </Container>
);

export default SecurePayment;
